module.exports = __webpack_public_path__ + "img/usa-blood-diseases-female.8db3851d.png";